export default __webpack_public_path__ + "static/media/measuring-tape.822b56f4.png";